import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import {
  IconButton,
  AppBar as MuiAppBar,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';

import { FC } from 'react';

export const AppBar: FC<{
  onLogout?: () => void;
  onMenuToggle?: () => void;
}> = props => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <MuiAppBar position='static' sx={{ zIndex: theme.zIndex.drawer + 1 }}>
      <Toolbar>
        {!isDesktop && (
          <IconButton
            aria-label='open menu'
            color='inherit'
            data-testid='menuToggle'
            edge='start'
            onClick={props.onMenuToggle}
            sx={{ mr: 2 }}>
            <MenuIcon />
          </IconButton>
        )}
        <Typography
          color='inherit'
          component='div'
          data-testid='panelTitle'
          sx={{ flexGrow: 1, textAlign: 'center' }}
          variant='h3'>
          Control Panel
        </Typography>
        <Tooltip title='Logout'>
          <IconButton
            aria-label='logout'
            color='inherit'
            data-testid='logout'
            edge='end'
            onClick={props.onLogout}>
            <LogoutIcon />
          </IconButton>
        </Tooltip>
      </Toolbar>
    </MuiAppBar>
  );
};

AppBar.displayName = 'AppBar';
